export interface Apis {
  expertPage: string;
  expertAdd: string;
  expertUpdate: string;
  expertDelete: string;
  expertDetail: string;
}
export const apis: Apis = {
  expertPage: '/iparkAdmin/expert/selectExpertByPage',
  expertAdd: '/iparkAdmin/expert/insertExpert',
  expertUpdate: '/iparkAdmin/expert/updateExpert',
  expertDelete: '/iparkAdmin/expert/deleteExpert',
  expertDetail: '/iparkAdmin/expert/selectExpertByExpertId'
}
